import { makeAutoObservable, toJS } from 'mobx'

import { UmrahBuyTourApi, UmrahMyOrder } from 'shared/api/umrah/buy-tour'
import { UmrahListApi, UmrahTour } from 'shared/api/umrah/tours'

const ItemsPerPage = 25

class UmrahListStore {
  listOfUmrah: UmrahTour[] | [] = []
  selectedUmrahTour?: UmrahTour | null = null
  abortController: AbortController | null = null
  lastTourAppeal?: UmrahMyOrder | null = null
  loading: boolean = false
  maxPage: number = 1
  page: number = 1

  constructor() {
    makeAutoObservable(this)
  }

  async requestUmrahList() {
    if (this.loading) return

    const queryParams = {
      page: this.page,
      per_page: ItemsPerPage,
    }

    if (this.abortController) {
      this.abortController.abort()
    }

    this.abortController = new AbortController()

    try {
      this.loading = true
      const { data: umrahData } = await UmrahListApi.getUmrahList(
        queryParams,
        this.abortController?.signal,
      )

      this.maxPage = umrahData.total_pages || 1
      this.page = this.page + 1

      this.setListOfUmrah(umrahData?.data)
    } catch (err) {
      this.loading = false
    } finally {
      this.loading = false
    }
  }

  setListOfUmrah(umrahTours: UmrahTour[]) {
    this.listOfUmrah = [...(this.listOfUmrah || []), ...umrahTours]
  }

  getUmrahList() {
    return toJS(this.listOfUmrah)
  }

  resetUmrahList() {
    this.listOfUmrah = []
    this.page = 1
    this.maxPage = 1
    this.loading = false

    if (this.abortController) {
      this.abortController.abort()
    }
  }

  async requestUmrahTour(tourId: string, scheduleId: string): Promise<void> {
    this.loading = true

    const params = {
      schedule_id: scheduleId,
    }

    try {
      const { data: umrahTour } = await UmrahListApi.getUmrahTour(
        tourId,
        params,
      )

      this.selectedUmrahTour = umrahTour?.data
    } catch (err) {
      throw err
    } finally {
      this.loading = false
    }
  }

  getUmrahTour() {
    return toJS(this.selectedUmrahTour)
  }

  setUmrahTour(tour?: UmrahTour) {
    this.selectedUmrahTour = tour
  }

  async requestUmraLastTour() {
    try {
      const { data: lastTour } = await UmrahBuyTourApi.getLastMyOrder()

      this.lastTourAppeal = lastTour?.data
    } catch (err) {
      this.lastTourAppeal = null
    }
  }

  getUmrahLastTour() {
    return toJS(this.lastTourAppeal)
  }
}

export default new UmrahListStore()
